import IconProhibit from "assets/img/icon-status-prohibit.svg?react"

import { ReactNode } from "react"

import Tooltip from "components/Tooltip/Tooltip"

interface ICustomerNumberBlockedIconProps {
    tooltipText?: ReactNode
}

const CustomerNumberBlockedIcon = ({
    tooltipText,
}: ICustomerNumberBlockedIconProps) => {
    const icon = (
        <IconProhibit
            width={20}
            height={20}
            className="color-red-500 d-block"
            data-testid="customer-number-blocked-icon"
        />
    )

    if (!tooltipText) {
        return icon
    }

    return (
        <Tooltip
            content={tooltipText}
            maxWidth="487px"
            trigger="hover">
            {icon}
        </Tooltip>
    )
}

export default CustomerNumberBlockedIcon
